import { render, staticRenderFns } from "./DeceasedInfo.vue?vue&type=template&id=1c21433a"
import script from "./DeceasedInfo.vue?vue&type=script&lang=ts"
export * from "./DeceasedInfo.vue?vue&type=script&lang=ts"
import style0 from "./DeceasedInfo.vue?vue&type=style&index=0&id=1c21433a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports